<div [formGroup]="parentForm!">
    <div class=" form-group">
        <div *ngIf="data && data.length > 0">
            <ul *ngFor="let document of data; let i=index">
              <li><a href="javascript:void(0)" (click)="downloadFile(document.fileId)">{{ document.name }}</a></li>
            </ul>
        </div>
        <div formArrayName="documentDatas">
            <div *ngFor="let file of documentDatas.controls; let i=index">
                <div class="row mb-1">
                    <div class="col">
                        <div [formGroupName]="i" class="custom-file">
                            <input
                                    (change)="onFileChange($event, i)"
                                    [ngClass]="{'is-invalid': file!.invalid && (file!.dirty || file!.touched)}"
                                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xls,.zip"
                                    class="custom-file-input"
                                    type="file"
                            />
                            <label class="custom-file-label">{{ file.value.name }}</label>
                        </div>
                    </div>
                    <div class="col-auto pt-2 ml--3">
                        <a (click)="removeFile(i)" class="shortcut-item">
                            <span>
                              <i class="ni ni-2x ni-fat-remove text-danger"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2" *ngIf="!this.isReadOnly">
            <a (click)="addUploadFormControl()" href="javascript:void(0)">
                <i aria-hidden="true" class="fa fa-plus"></i> Additional Upload
            </a>
        </div>
    </div>
</div>
